import { ToastRegion } from "@baton/ui";

/**
 * FR-015-091, FR-015-102, `contracts/screens.md` § Toast region, `contracts/design-system.md`
 * § Live regions: the toast region mounts once here, bottom-right, at most three visible
 * with the rest queued and each carrying its action; the two live regions (polite for
 * successes, assertive for failures) are the `LiveRegion` provider `main.tsx` wraps the
 * router in, so an announcement from any screen reaches the same two elements.
 */
export function Regions() {
  return <ToastRegion />;
}
